import { lazy } from 'react';

const VerificationEmailPage = lazy(() => import('./pages/VerificationEmailPage'));

export const VerificationEmailEntry = () => <VerificationEmailPage />;
